import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RotateCcw, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { errMsg, useApi } from "@/lib/api";

export const Narrative = ({ companyId, rep, onChange }) => {
  const api = useApi();
  const [n, setN] = useState(rep.narrativa);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setN(rep.narrativa);
  }, [rep.narrativa]);

  const save = async () => {
    setBusy(true);
    try {
      await api("put", `/companies/${companyId}/gri306/narrativa`, { ...rep.periodo, n306_1: n.n306_1, n306_2: n.n306_2 });
      toast.success("Textos guardados para este periodo");
      onChange();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const reset = async () => {
    await api("delete", `/companies/${companyId}/gri306/narrativa?desde=${rep.periodo.desde}&hasta=${rep.periodo.hasta}`);
    toast.success("Se regeneró el borrador con los datos actuales");
    onChange();
  };

  const field = (k, code, title, hint) => (
    <div className="space-y-2">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00b37a]">GRI {code}</p>
      <h2 className="text-lg font-semibold text-[#05130e]">{title}</h2>
      <p className="text-sm text-slate-500">{hint}</p>
      <Textarea rows={7} value={n[k]} onChange={(e) => setN({ ...n, [k]: e.target.value })} className="bg-white rounded-2xl text-sm leading-relaxed" data-testid={`gri-narrative-${code}`} />
    </div>
  );

  return (
    <section className="space-y-6" data-testid="gri-narrative-section">
      {field("n306_1", "306-1", "Generación de residuos e impactos significativos", "Dónde y por qué se generan los residuos en la cadena de valor, y qué materiales tienen mayor riesgo ambiental.")}
      {field("n306_2", "306-2", "Gestión de los impactos significativos", "Acciones de mitigación: trazabilidad, homologación de gestores autorizados y segregación en origen.")}
      <div className="flex flex-wrap items-center gap-3">
        <Button onClick={save} disabled={busy} className="rounded-full" data-testid="gri-narrative-save"><Save className="w-4 h-4" />{busy ? "Guardando..." : "Guardar textos"}</Button>
        {rep.narrativa.editado && <Button variant="ghost" onClick={reset} className="rounded-full" data-testid="gri-narrative-reset"><RotateCcw className="w-4 h-4" />Volver al borrador automático</Button>}
        <span className="text-xs text-slate-500" data-testid="gri-narrative-status">{rep.narrativa.editado ? `Editado el ${new Date(rep.narrativa.updated_at).toLocaleString("es-CL")}` : "Borrador automático generado con tus datos. Revísalo y ajústalo."}</span>
      </div>
    </section>
  );
};
